// calculate header height - check for v2 header first for A/B testing

// TODO: After A/B testing is complete, remove the A/B detection logic and revert to simpler version
// Old version (commented out for A/B testing):
// window.header_height = document.querySelector("header").offsetHeight;
// document.documentElement.style.setProperty("--header-height", header_height + "px");
// document.documentElement.dataset.header_height = header_height;
//
// Why commented: The old version always selected the first <header> element, which during A/B testing
// would be the original header. This caused header-v2's dropdown to position incorrectly because it
// was using the original header's height instead of header-v2's height.

const headerV2 = document.querySelector("header.header-v2");
const headerOriginal = document.querySelector("header:not(.header-v2)");
let activeHeader;

// Determine which header is visible/active
if (headerV2) {
  const headerV2Style = window.getComputedStyle(headerV2);
  if (headerV2Style.display !== "none" && headerV2Style.visibility !== "hidden") {
    activeHeader = headerV2;
  }
}

// Fallback to original header if v2 not visible or doesn't exist
if (!activeHeader && headerOriginal) {
  activeHeader = headerOriginal;
}

// Fallback to any header element
if (!activeHeader) {
  activeHeader = document.querySelector("header");
}

window.header_height = activeHeader ? activeHeader.offsetHeight : 0;
document.documentElement.style.setProperty(
  "--header-height",
  header_height + "px"
);
document.documentElement.dataset.header_height = header_height;

// Cookies

function getBannerEl() {
  return document.getElementById("cookies-banner");
}

function hideBanner(res) {
  getBannerEl().classList.remove("active");
  sessionStorage.setItem("cookies_accepted_by_default", "");
}

function showBanner() {
  getBannerEl().classList.add("active");
}

function cookies_accepted_by_default() {
  sessionStorage.setItem("cookies_accepted_by_default", "1");
}

function handleAccept(e) {
  window.Shopify.customerPrivacy.setTrackingConsent(
    true,
    cookies_accepted_by_default
  );
  document.addEventListener("trackingConsentAccepted", function () {
    console.log("trackingConsentAccepted event fired");
  });
}

function handleDecline() {
  window.Shopify.customerPrivacy.setTrackingConsent(false, hideBanner);
}

function initCookieBanner() {
  const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
  const userTrackingConsent =
    window.Shopify.customerPrivacy.getTrackingConsent();

  if (!userCanBeTracked && userTrackingConsent === "no_interaction") {
    showBanner();
    handleAccept();
  }

  if (sessionStorage.getItem("cookies_accepted_by_default") === "1") {
    showBanner();
  }
}

window.Shopify.loadFeatures(
  [
    {
      name: "consent-tracking-api",
      version: "0.1",
    },
  ],
  function (error) {
    if (error) {
      throw error;
    }

    initCookieBanner();
  }
);

// popup

let popup = document.querySelector(".popup");
let popup_overlay = document.querySelector(".popup__overlay");
let popup_close = document.querySelector(".popup__close-icon");
let hide_popup = localStorage.getItem("hide_popup");

if (popup) {
  let popup_delay = popup.dataset.delay;
  if (hide_popup !== "true") {
    setTimeout(function () {
      popup.classList.add("active");
      popup_overlay.classList.add("active");
      document.querySelector("body").classList.add("active-mobile");
    }, popup_delay);
    popup_close.onclick = function () {
      popup.classList.remove("active");
      popup_overlay.classList.remove("active");
      document.querySelector("body").classList.remove("active-mobile");
      localStorage.setItem("hide_popup", true);
    };
  }
}

// popup ads

const $popupAds = document.querySelector(".popup-ads_content-wrapper");
const $popupAds_overlay = document.querySelector(".popup-ads_overlay");
const $popupAds_close = document.querySelector(".popup-ads_close-icon");
const $popupAds_link = document.querySelector(".popup-ads_link");
let hide_popupAds = localStorage.getItem("hide_popupAds");

if ($popupAds) {
  let popupAds_delay = $popupAds.dataset.delay;
  if (hide_popupAds !== "true") {
    setTimeout(function () {
      $popupAds.classList.add("active");
      $popupAds_overlay.classList.add("active");
    }, popupAds_delay);
    $popupAds_close.onclick = function () {
      $popupAds.classList.remove("active");
      $popupAds_overlay.classList.remove("active");
      localStorage.setItem("hide_popupAds", true);
    };
    $popupAds_overlay.onclick = function () {
      $popupAds.classList.remove("active");
      $popupAds_overlay.classList.remove("active");
      localStorage.setItem("hide_popupAds", true);
    };
    $popupAds_link.onclick = function () {
      $popupAds.classList.remove("active");
      $popupAds_overlay.classList.remove("active");
      localStorage.setItem("hide_popupAds", true);
      console.log("popup closed");
    };
  }
}

// handle hash in url

let hash = window.location.hash.substr(1);
if (hash === "cart") {
  document.querySelector(".header-icon__cart").click();
}

// back to top func

BacktoTop_btn = document.querySelector(".back-to-top");
let BacktoTopFunc = function () {
  let y = window.scrollY;
  if (y >= 600) {
    BacktoTop_btn.style.opacity = "1";
  } else {
    BacktoTop_btn.style.opacity = "0";
  }
};
window.addEventListener("scroll", BacktoTopFunc);

// recover password notifications

let recover_form = document.querySelector("#recover-password-form form");

if (recover_form !== null) {
  const recover_submit_btn = recover_form.querySelector(".cta");
  recover_submit_btn.onclick = function () {
    sessionStorage.setItem("recover", "true");
    // trigger click on real btn
    recover_form.querySelector(".real_trigger").click();
  };

  if (sessionStorage.getItem("recover") === "true") {
    const $toggleBtn = document.querySelector(
      ".customer-form__login-recover-password div"
    );
    window.addEventListener("functions-enabled", function () {
      $toggleBtn.click();
      sessionStorage.setItem("recover", "false");
    });
  }
}

// pre-fill email field with previously entered email

let login_form = document.querySelector("#login-form");

if (login_form !== null) {
  let login_submit_btn = login_form.querySelector(".cta");

  // save email in storage on click

  login_submit_btn.onclick = function () {
    let email = login_form.querySelector("#email").value;
    sessionStorage.setItem("email", email);
    login_form.querySelector(".real_trigger").click();
  };

  // prefill input fields with saved email

  if (sessionStorage.getItem("email") !== null) {
    login_form.querySelector("#email").value = sessionStorage.getItem("email");
  }
}

function checkPassword(form) {
  if (form !== null) {
    let submit_btn = form.querySelector(".cta");
    submit_btn.onclick = function () {
      let password_field_1 = form.querySelector("#password");
      let password_field_2 = form.querySelector("#password-confirmation");

      // check if password are similar on register-form

      if (password_field_1.value === password_field_2.value) {
        // remove password errors

        form.querySelector("#password-not-similar").classList.add("hidden");
        password_field_1.classList.remove("error-field");
        password_field_2.classList.remove("error-field");
        form
          .querySelector("label[for='password']")
          .classList.remove("error-field");
        form
          .querySelector("label[for='password-confirmation']")
          .classList.remove("error-field");
      } else {
        // show password errors

        form.querySelector("#password-not-similar").classList.remove("hidden");
        password_field_1.classList.add("error-field");
        password_field_2.classList.add("error-field");
        form
          .querySelector("label[for='password']")
          .classList.add("error-field");
        form
          .querySelector("label[for='password-confirmation']")
          .classList.add("error-field");
        return;
      }

      // check password length

      const passwordLength = password_field_1.value.length;

      if (passwordLength >= 5) {
        // remove password errors

        form.querySelector("#password-too-short").classList.add("hidden");
        password_field_1.classList.remove("error-field");
        password_field_2.classList.remove("error-field");
        form
          .querySelector("label[for='password']")
          .classList.remove("error-field");
        form
          .querySelector("label[for='password-confirmation']")
          .classList.remove("error-field");

        // trigger click on real btn
        form.querySelector(".real_trigger").click();
      } else {
        // show password errors

        form.querySelector("#password-too-short").classList.remove("hidden");
        password_field_1.classList.add("error-field");
        password_field_2.classList.add("error-field");
        form
          .querySelector("label[for='password']")
          .classList.add("error-field");
        form
          .querySelector("label[for='password-confirmation']")
          .classList.add("error-field");
        return;
      }
    };
  }
}

// password verification on register-form

let register_form = document.querySelector(".customer-form__register form");
checkPassword(register_form);

// check if password are similar on activate-account-form

let activate_form = document.querySelector(
  ".customer-form__activate-account form"
);
checkPassword(activate_form);

// check if password are similar on reset-password form

let reset_password_form = document.querySelector(
  ".customer-form__reset-password form"
);
checkPassword(reset_password_form);

// private sales function
const isCollection = document.querySelector(".collection-template");
if (isCollection) {
  const isVP = isCollection.querySelector(".collection-wrapper").dataset.vp;
  if (isVP === "true") {
    handleVP();
  }
}

function handleVP() {
  // handle redirect

  const $loginBtn = document.querySelector(".private-sales_popup-login-btn");
  const $signupBtn = document.querySelector(".private-sales_popup-signup-link");
  const url = document.querySelector(".collection-wrapper").dataset.url;

  $loginBtn.addEventListener("click", () => {
    sessionStorage.setItem("currentUrl", url);
    window.location.href = "/account/login?return_url=%2Faccount";
  });

  $signupBtn.addEventListener("click", () => {
    sessionStorage.setItem("currentUrl", url);
    window.location.href = "/account/register";
  });

  // handle popup position

  const $sectionToObserve = document.querySelector(".collection-template");

  const observer = new IntersectionObserver((entries) => {
    // TODO: After A/B testing, this can be simplified back to: document.querySelector("header").offsetHeight
    // Old version: const headerHeight = document.querySelector("header").offsetHeight;
    // Why changed: During A/B testing with two headers, we need to use the pre-calculated height
    // from the active header (window.header_height) instead of always querying the first header element.
    const headerHeight = window.header_height || document.querySelector("header").offsetHeight;
    const height = window.innerHeight - headerHeight - 1;

    entries.forEach((entry) => {
      if (entry.intersectionRect.height < height) {
        $sectionToObserve.classList.remove("visible");
      } else {
        $sectionToObserve.classList.add("visible");
      }
      observer.disconnect();
    });
  });

  window.addEventListener("scroll", () => {
    observer.observe($sectionToObserve);
  });

  window.dispatchEvent(new Event("scroll"));
}
